var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWosck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13104 -1897)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-13104 1897)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.595 -2.596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2756.594,150.65c0,1.83.014,3.659-.009,5.489-.006.454.149.568.582.566,3.586-.015,7.172-.008,10.758-.008.176,0,.353,0,.526.015.529.053.816.37.678.9a18.864,18.864,0,0,1-.956,3.129,11.127,11.127,0,0,1-7.1,6.341,11.351,11.351,0,0,1-11.469-2.5,11.015,11.015,0,0,1-3.582-5.908,11.57,11.57,0,0,1,3.463-11.56,11.532,11.532,0,0,1,6.162-2.932c.583-.1.947.233.949.891C-2756.59,146.932-2756.594,148.791-2756.594,150.65Zm-2.274-3.742a9.39,9.39,0,0,0-6.337,9.587,9.59,9.59,0,0,0,9.958,8.859,9.3,9.3,0,0,0,8.393-6.346c-.194-.01-.379-.028-.565-.029q-5.423,0-10.845,0c-.6,0-.6,0-.6-.614q0-5.423,0-10.845Z",
    transform: "translate(-10329.494 1762.525)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2614.7,136.586v-10.57c0-1.025.288-1.272,1.3-1.14a11.7,11.7,0,0,1,9.33,6.587,11.793,11.793,0,0,1,1.146,4.07c.089.734-.224,1.069-.967,1.07q-5.288.005-10.577,0C-2614.527,136.6-2614.582,136.6-2614.7,136.586Z",
    transform: "translate(-10468.885 1780.148)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWosck);
export default __webpack_public_path__ + "static/media/wosck.1693e45b.svg";
export { ForwardRef as ReactComponent };